
    import {Component, Vue} from 'vue-property-decorator';

    @Component<Social>({})
    export default class Social extends Vue
    {
    }
